import apiTransactionProduct from '@/api/vo/transactionProduct';

const defaultState = () => ({
	listProduct: [],
	listProductPagination: '',
	listProductSeries: [],
	listProductSeriesPagination: '',
	listProductItem: [],
	listProductItemPagination: '',
	detailProduct: {},

	listTransaction: [],
	transactionPagination: '',
	listTransactionUpload: [],
	transactionUploadPagination: '',
	detailTransaction: {},

	responseSuccess: {},
	errorValidation: [],
});

const state = defaultState();

const getters = {};

const mutations = {

	setListProduct(state, data) {
		data.data.map( (el) => {
			el['quantity'] = 1
			el['checked'] = false
			el['product_charge_price'] = parseInt(el.product_member_price) + parseInt(el.product_admin_charge_value)
			el['product_last_price'] = (parseInt(el.product_member_price) + parseInt(el.product_admin_charge_value)) - parseInt(el.product_discount_value)
			el['total'] = parseInt(el.quantity) * parseInt(el.product_last_price)
			return el;
		});
		state.listProduct = data.data;
		state.listProductPagination = data.pagination;
	},
	setListProductSeries(state, data) {
		data.data.map( (el) => {
			el['quantity'] = 1
			el['checked'] = false
			el['product_charge_price'] = parseInt(el.product_member_price) + parseInt(el.product_admin_charge_value)
			el['product_last_price'] = (parseInt(el.product_member_price) + parseInt(el.product_admin_charge_value)) - parseInt(el.product_discount_value)
			el['total'] = parseInt(el.quantity) * parseInt(el.product_last_price)
			return el;
		});
		state.listProductSeries = data.data;
		state.listProductSeriesPagination = data.pagination;
	},
	setListProductItem(state, data) {
		data.data.map( (el) => {
			el['quantity'] = 1
			el['checked'] = false
			el['product_charge_price'] = parseInt(el.product_member_price) + parseInt(el.product_admin_charge_value)
			el['product_last_price'] = (parseInt(el.product_member_price) + parseInt(el.product_admin_charge_value)) - parseInt(el.product_discount_value)
			el['total'] = parseInt(el.quantity) * parseInt(el.product_last_price)
			return el;
		});
		state.listProductItem = data.data;
		state.listProductItemPagination = data.pagination;
	},
	setDetailProduct(state, data) {
		state.detailProduct = data.data
	},
	clearDetailProduct(state) {
		state.detailProduct = {}
	},

	setListTransaction(state, data) {
		state.listTransaction = data.data;
		state.transactionPagination = data.pagination;
	},
	setListTransactionUpload(state, data) {
		state.listTransactionUpload = data.data;
		state.transactionUploadPagination = data.pagination;
	},
	setDetailTransaction(state, data) {
		state.detailTransaction = data.data
	},

	setSuccessTransaction(state, data) {
		state.responseSuccess = data.data
	},
	setErrorValidation(state, data) {
		state.errorValidation = data
	},
};

const actions = {

	getListProduct({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getListProduct(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListProduct', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data produk tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},
	getListProductSeries({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getListProductSeries(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListProductSeries', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data produk tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},
	getListProductItem({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getListProductItem(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListProductItem', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data produk tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},
	getDetailProduct({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getDetailProduct(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDetailProduct', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data produk tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},

	getListTransaction({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getListTransaction(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListTransaction', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data transaksi tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},
	getListTransactionUpload({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getListTransactionUpload(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setListTransactionUpload', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data transaksi tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},
	getDetailTransaction({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.getDetailTransaction(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDetailTransaction', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, data transaksi tidak dapat ditampilkan.'
				}, { root: true });
				reject()
			});
		});
	},

	addTransactionProduct({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.addTransactionProduct(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuccessTransaction', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, transaksi produk tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},
	addTransactionProductPickup({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.addTransactionProductPickup(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					commit('setSuccessTransaction', data.results)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, transaksi produk tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	uploadPayment({ dispatch, commit }, value) {
		return new Promise((resolve, reject) => {
			apiTransactionProduct.uploadPayment(value).then((results) => {
				const data = results.data;
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve()
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			})
			.catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Upload bukti pembayaran tidak dapat diproses!'
				}, { root: true });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};